import React from "react";

import { InfoModalResDto } from "@/models/infoModalRes.dto";

import { useOpenModal } from "../../utils/openModal";
import { InfoModal } from "./Info.modal";

export const CommonInfoModal: React.FC<
  InfoModalResDto & {
    onOkClick?: () => void;
    disableonOkClickOnCross?: boolean;
    buttonText?: string;
    headerName?: string;
  }
> = ({
  message,
  statusReg,
  onOkClick,
  buttonText,
  disableonOkClickOnCross,
  headerName,
}) => {
  const { removeOne } = useOpenModal();

  return (
    <InfoModal
      onOkClick={onOkClick || removeOne}
      statusReg={statusReg}
      disableonOkClickOnCross={disableonOkClickOnCross}
      headerName={headerName}
    >
      <InfoModal.Message>{message}</InfoModal.Message>
      <InfoModal.ButtonContainer>
        <InfoModal.Button onClick={onOkClick || removeOne}>
          {buttonText || "OK"}
        </InfoModal.Button>
      </InfoModal.ButtonContainer>
    </InfoModal>
  );
};
